<template>
    <div class="card p-3 rounded-more d-flex flex-column gap user-select-none">
        <div class="d-flex flex-row gap-0.5">
            <div class="rect"></div>
            <h4 class="text-md text-bold">Type</h4>
        </div>
        <div class="d-flex flex-row gap mt-3 justify-content-end align-items-center">
            <div class="text-lg text-bold">{{ibLevel}}</div>
            <router-link to="/introduction-broker/type" class="link">
                <i class="fas fa-chevron-right fa-2x"></i>
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    name : "TypeIbCard",
    props : {
        level : String
    },
    computed : {
        ibLevel(){
            let levels = {
                'INTRODUCING_BROKER' : 'Agent',
                'PARTNER_IB' : 'Supervisor Area',
                'MASTER_IB' : 'Manager Area'
            }

            return levels[this.level] ?? '-'
        }
    }
}
</script>